import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import asyncComponent from "../../../util/asyncComponent";

const AccountTransfers = ({ match }) => {
  const authUser = useSelector((state) => state.auth.authUser);
  const hasAccess = authUser && authUser.Claims.includes("admin.access");

  return (
    <div className="app-wrapper">
      <Switch>
        {hasAccess && (
          <Redirect exact from={`${match.url}/`} to={`${match.url}/config`} />
        )}
        {hasAccess && (
          <Redirect exact from={match.url} to={`${match.url}/config`} />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/create`}
            component={asyncComponent(() => import("./routes/CreateTransfer"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/config`}
            component={asyncComponent(() => import("./routes/Config"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/monitoring`}
            component={asyncComponent(() => import("./routes/Monitoring"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/activity`}
            component={asyncComponent(() => import("./routes/Activity"))}
          />
        )}
        {hasAccess && (
          <Route
            exact
            path={`${match.url}/attention`}
            component={asyncComponent(() => import("./routes/Attention"))}
          />
        )}
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default AccountTransfers;
